module.exports = __webpack_public_path__ + "img/doc_e.d4a54eb4.png";